import styled from "styled-components";

const AquaButton = styled.button`
  background: linear-gradient(145deg, #cde03cff, #2eb82e); /* green gradient */
  color: white;
  border: none;
  padding: 18px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 20px;
  cursor: pointer;
  box-shadow:
    0 4px 10px rgba(0, 128, 0, 0.3),
    inset 0 2px 6px rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;

  @media (max-width: 900px) {
    padding: 20px 24px;
  }

  &:hover {
    background: linear-gradient(145deg, #2eb82e, #29a329);
    box-shadow:
      0 6px 14px rgba(0, 128, 0, 0.4),
      inset 0 2px 8px rgba(255, 255, 255, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    background: linear-gradient(145deg, #29a329, #248f24);
    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.3);
    transform: translateY(1px);
  }
`;

export default AquaButton;
